module.exports = __webpack_public_path__ + "img/info-icon-green.9aa867e8.svg";